module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAYAAAARx7TFAAAAcUlEQVQImU3KoQ4BcBzE8cPGWyhUQVQ1xQuKRIUnEQRdk8zGJB/7zd+47Xa7710H6yTDJIskj/w0SLJN8gqOPtqjj2I97Bo/FRjh3MAGXaxav2Bcp/IE1zYcWlaf1v49lWe4t8MT8+/2fyovcWv5YeQN4SOhk12K0dEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon2.png
// module id = ceFa
// module chunks = 42